import { yearsDecimalFormat } from 'common/formats/formats';
import {
  ALLOCATION_SCENARIO_METHOD_OPM,
  ALLOCATION_SCENARIO_TYPE_BACKSOLVE,
  ALLOCATION_SCENARIO_TYPE_FUTURE_EXIT,
} from 'pages/ValuationsAllocation/common/constants/allocation';
import { EQUITY_ALLOCATION_MATURITY_MAX_VALUE } from 'pages/ValuationsAllocation/common/constants/equityAllocation';
import { getNumberValue } from 'utillities';
import { HandleMaturityParams } from './types';

const handleMaturity = (params: HandleMaturityParams) => {
  const { cell, isApproachWithOPM, scenarioMethod, scenarioType } = params;

  cell.format = yearsDecimalFormat;
  cell.greaterThan = 0;
  cell.gridType = 'number';
  cell.isRequired = true;
  cell.maxValue = EQUITY_ALLOCATION_MATURITY_MAX_VALUE; // Default max value for Maturity

  if (
    [ALLOCATION_SCENARIO_TYPE_BACKSOLVE, ALLOCATION_SCENARIO_TYPE_FUTURE_EXIT].includes(getNumberValue(scenarioType))
  ) {
    cell.readOnly = true;
  }

  if (![ALLOCATION_SCENARIO_METHOD_OPM].includes(getNumberValue(scenarioMethod)) && !isApproachWithOPM) {
    cell.hidden = true;
    cell.isRequired = false;
    cell.readOnly = true;
  }
};

export default handleMaturity;
